module.exports = "/_next/static/images/ourPartnersATTLogo-42a25594a11e90a2260f0a74ec049e86.webp";